<template>
    <el-main class="container" :class="{ 'container-transform': $store.getters.isCollapse }">
        <div class="title">{{ title }}</div>
        <div class="container-inner clearfix">
            <el-breadcrumb
                    class="breadcrumb"
                    separator-class="el-icon-arrow-right"
                    ref="breadcrumb"
            >
                <template v-for="(route, index) in breadcrumbData">
                    <el-breadcrumb-item
                            :to="{ path: route.path }"
                            :key="index"
                            :class="index == breadcrumbData.length - 1 ? 'text-color' : ''"
                    >{{ route.meta.name }}
                    </el-breadcrumb-item>
                </template>
            </el-breadcrumb>
            <slot></slot>
        </div>
    </el-main>
</template>
<script>
    export default {
        name: "Container",
        data() {
            return {
                title: ""
            };
        },
        computed: {
            breadcrumbData() {
                let routes = this.$store.getters.currentRoute.matched;

                if (routes[routes.length - 1] != undefined) {
                    this.title = routes[routes.length - 1].meta.name;
                    document.title = "儒悘网管理后台-" + this.title
                }

                return routes;
            }
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .container {
        position: absolute;
        // overflow-y: scroll;
        top: 60px;
        right: 0;
        bottom: 0;
        left: 179px;
        padding-left: 40px !important;
        transition: left 0.28s 0.28s;

        .container-inner {
            padding: 20px;
            border-radius: 5px;
            border: 1px solid $lightGray;
            background: white;
            box-sizing: border-box;
            margin-top: 20px;
        }

        .breadcrumb {
            margin-bottom: 20px;
        }

        & > .title {
            position: relative;
            font-size: 14px;
            font-weight: bolder;
            padding-left: 10px;
            box-sizing: border-box;
            text-align: left;
        }

        & > .title::before {
            content: "";
            display: block;
            background: $dominantHue;
            width: 5px;
            height: 20px;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -10px;
        }

        & .breadcrumb {
            position: relative;
            margin-left: 15px;
        }

        & .breadcrumb::before {
            content: "";
            display: block;
            background: $dominantHue;
            width: 5px;
            height: 20px;
            position: absolute;
            left: -15px;
            top: 50%;
            margin-top: -10px;
        }

        & .text-color {
            & > .is-link {
                color: $dominantHue !important;
            }
        }
    }

    .container-transform {
        left: 65px !important;
    }
</style>

